module.exports = __webpack_public_path__ + "static/media/contentExample6.aa7c4782.png";